/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * ChevronsUpIcon
 */
export default class ChevronsUpIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M7.7 11.7L12 7.4l4.3 4.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4l-5-5c-.4-.4-1-.4-1.4 0l-5 5c-.4.4-.4 1 0 1.4s1 .4 1.4 0z"/><path d="M12.7 12.3c-.4-.4-1-.4-1.4 0l-5 5c-.4.4-.4 1 0 1.4s1 .4 1.4 0l4.3-4.3 4.3 4.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4l-5-5z"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

